<style scoped>
.visa-frame {
  margin: 32px
}
@media only screen and (max-width: 480px) {
  .visa-frame {
    margin: 32px 0px 
  }
}

</style>

<template>
  <div> 
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 40%; max-width: 200px">
        <img src="/static/mandatexpress.svg">
      </div>
    </div>

    <div v-if="!paymentDone">
      <div style="padding: 16px"><h2>Payment with International Express Money Order</h2></div>

      <md-card v-if="$route.params.cart == 'VISA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Help with your visa application file 120&euro; TTC</div>
            <div class="md-subhead">Help with your visa application file</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="$route.params.cart == 'CRRV'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Appeal to the Appeals Board on Visa Refusals 299&euro; TTC</div>
            <div class="md-subhead">Appeal to the Appeals Board on Visa Refusals </div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>

      <md-card v-if="$route.params.cart == 'TA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Appeal to the Administrative Court of Nantes 299&euro; TTC</div>
            <div class="md-subhead">Appeal to the Administrative Court of Nantes</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>

      <md-card v-if="$route.params.cart == 'PREMIUM'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Premium Pack 999&euro; TTC</div>
            <div class="md-subhead">You are assisted and defended by a specialised lawyer.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/lawyer.svg">
          </md-card-media>
        </md-card-header>
      </md-card>
      

      <div class="light-frame visa-frame" >
        <p>If you click on the “pay” button you accept to go  <u>in a poste office </u> to make an International Express Money Order for the OCTAGRAM SAS account, GetMyVIsaToFrance operatore :</p>
        <p style="padding-left: 16px">
          <b>Name of the company : OCTAGRAM SAS</b><br>
          <b>Adress : 59 rue Chardon Lagache 75016 Paris</b>
        </p>
        <p>We will send you the details of the procedure by email once you accept the engagement conditions</p>

        <div class="centered-child" style="margin-top: 24px">
          <md-button class="md-raised md-primary large-button" 
          @click="onClickPay()"
          :disabled="loading">
            <span>Pay</span> 
          </md-button>
        </div>
      </div>

 
    </div>
    <div v-else>
        <h2>Waiting for the International Express Money Order payment reception</h2>
        <p>An confirmation email has just been sent to you<p>
        <p>Once the International Express Money Order transfer made please follow the instruction that you received by email 
          To indicate the money order reference in order to finish to create your file.</p>

        <div class="centered-child" style="margin-top: 48px">
          <md-button class="md-raised md-primary large-button"
           @click="onClickContinue()"
           >Continue</md-button>
        </div>


    </div>
  </div>
</template>

<script>

import ServiceAccess from '../service/ServiceAccess'

export default {
  data: function () {
    return {
      loading: false,
      paymentDone: false
    }
  },






  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)
    


    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [values] = responses
      this.values = values
    })
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      if (this.paymentDone) {
        this.$router.replace('/f/' + this.$route.params.sessionId + '/')
      } else {
        this.$router.back()
      }
    },

    onClickPay: function () {   
      this.loading = true
      let medium = 'mandat-express'
      ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-pay', {kind: medium})

      ServiceAccess.instance.checkoutWire(this.$route.params.sessionId, medium, this.$route.params.cart).then(resp => {
        this.loading = false
        this.paymentDone = true
        this.values.id_virement_type = medium
        this.values.id_attente_virement = true
        this.trackAdsConversion()
      }, err => {
        this.loading = false
        console.error('Failed Wire checkout: ', err)
      })

    },

    trackAdsConversion: function () {
      /* eslint-disable camelcase */
      /* eslint-disable no-unused-vars */
      var google_conversion_id = 865811613
      var google_conversion_language = 'en'
      var google_conversion_format = '3'
      var google_conversion_color = 'ffffff'
      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM'
      var google_remarketing_only = false
      
      var script = document.createElement('script')
      script.src = '//www.googleadservices.com/pagead/conversion.js'

      var image = new global.Image(1, 1)
      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0'
    },



    onClickContinue: function () {
      this.$router.replace('/f/' + this.$route.params.sessionId + '/')
    }

  }


}
</script>


// WEBPACK FOOTER //
// CheckoutMandatExpress.vue?54e10468